var map = {
	"./index.vue": 8880,
	"./login.vue": 3937,
	"./minecate.vue": 4290,
	"./minelucky.vue": 9744,
	"./minetask.vue": 6723,
	"./ref.vue": 1359,
	"./stat.vue": 6613,
	"./task.vue": 5663,
	"./uref.vue": 222
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5535;